import { render, staticRenderFns } from "./HistoricoStatus.vue?vue&type=template&id=4561fb16"
import script from "./HistoricoStatus.vue?vue&type=script&lang=js"
export * from "./HistoricoStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports